import Condition from './Condition'

export default class State {

  constructor (obj) {
    this.id = obj.id
    this.qid = obj.qid
    this.transitions = obj.transitions
    this.target = obj.target
    this.targetScreen = obj['target-screen']
  }
  
  // --------------------------------------------------------------------------
  nextStateIdAndScreenId (v, values) {

    if (this.target != null) {
      return [this.target, null]
    }
    if (this.targetScreen != null) {
      return [null, this.targetScreen]
    }

    let nextStateId = null
    let nextScreenId = null


    if (this.transitions == null) {
      return [null, null]
    }
    if (v == null && this.transitions.length > 0) {
      return [null, null]
    }

    for (let transistion of this.transitions) {
      if (transistion.condition != null) {
        
        if (v != null && Condition.evalCondition(transistion.condition, values, v)) {
          if ('target' in transistion) {
            nextStateId = transistion.target
          } else if ('target-screen' in transistion) {
            nextScreenId = transistion['target-screen']
          }
          break
        }
      } else {
        if ('target' in transistion) {
          nextStateId = transistion.target
        } else if ('target-screen' in transistion) {
          nextScreenId = transistion['target-screen']
        }
        break
      }
    }

    return [nextStateId, nextScreenId]
  }

}



// WEBPACK FOOTER //
// ./src/model/State.js